import posthog from 'posthog-js';

import { POSTHOG_KEY, POSTHOG_HOST, DEVELOPMENT } from 'src/config-global';

posthog.init(POSTHOG_KEY, {
  api_host: POSTHOG_HOST,
  person_profiles: 'identified_only',
  capture_pageview: true,
  capture_pageleave: true,
  capture_exceptions: true,
  autocapture: false,
  feature_flag_request_timeout_ms: 10000,
  disable_persistence: DEVELOPMENT,
});

export default posthog;
